import { Box, Typography, Container } from "@mui/material";
import React from "react";
import Swipe from "../common/GalleryComponent/Swipe";
import Equipo from "../../assets/images/equipo.png";
import useMediaQuery from "@mui/material/useMediaQuery";

function SuccessStories() {
  const mobMatch = useMediaQuery("(max-width:600px)");

  return (
    <Container
      disableGutters={true}
      sx={{
        borderRadius: { xs: "8px", sm: "0px" },
        boxShadow: {
          xs: "0px 1px 1px rgba(0, 0, 0, 0.14), 0px 2px 1px rgba(0, 0, 0, 0.12), 0px 1px 3px rgba(0, 0, 0, 0.2)",
          sm: "none",
        },
        backgroundColor: { xs: "#fff", sm: "" },
        marginY: { sm: "72px" },
        padding: { xs: "24px 16px", sm: "0px" },
      }}
    >
      <Box>
        <Typography
          sx={{
            fontWeight: { xs: 600, sm: 700 },
            fontSize: { xs: "22px", sm: "32px" },
            lineHeight: { xs: "26px", sm: "36px" },
          }}
          variant={mobMatch ? "h3" : "h2"}
        >
          Success stories
        </Typography>
        <Box
          sx={{
            width: "100%",
            display: "flex",
            alignItems: "bottom",
            justifyContent: "space-between",
            marginTop: { xs: "6px", sm: "0px" },
          }}
        >
          <Typography
            sx={{
              width: { sm: "600px" },
              fontWeight: 400,
              color: "#616161",
              fontSize: { xs: "12px", sm: "16px" },
              lineHeight: { xs: "16px", sm: "24px" },
            }}
            variant={mobMatch ? "caption" : "body1"}
          >
            We aim to build a smooth and straightforward relationship between
            our users, providing a streamlined solution that suits their needs.
          </Typography>
          {!mobMatch && (
            <Box
              sx={{ display: "flex", columnGap: "24px", alignItems: "center" }}
            >
              <Swipe direction="left" />
              <Typography
                sx={{ fontSize: "22px", lineHeight: "26px", fontWeight: 600 }}
                variant="h3"
              >
                1/4
              </Typography>
              <Swipe direction="right" />
            </Box>
          )}
        </Box>
        <Box
          sx={{
            marginTop: { xs: "16px", sm: "30px" },
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            columnGap: "53px",
          }}
        >
          {!mobMatch && (
            <Box>
              <Typography
                sx={{ fontSize: "48px", lineHeight: "52px", fontWeight: 700 }}
                variant="h1"
              >
                “
              </Typography>
              <Typography
                sx={{ fontSize: "22px", lineHeight: "26px", fontWeight: 600 }}
                variant="h3"
              >
                It's definitely opened up an entire other revenue stream for us.
              </Typography>
              <Box
                sx={{
                  marginTop: "56px",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <Box
                  sx={{
                    width: "80px",
                    height: "80px",
                    borderRadius: "100px",
                    border: "1px solid #1f1f1f",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    marginRight: "16px",
                  }}
                >
                  <img src={Equipo} width="44px" height="44px" alt="equipo" />
                </Box>
                <Box>
                  <Typography
                    sx={{
                      fontSize: "22px",
                      lineHeight: "26px",
                      fontWeight: 600,
                    }}
                    variant="h3"
                  >
                    Joshua Esnard
                  </Typography>
                  <Typography
                    sx={{
                      color: "#616161",
                      fontSize: "16px",
                      lineHeight: "24px",
                      fontWeight: 600,
                    }}
                    variant="subtitle"
                  >
                    Equippo
                  </Typography>
                </Box>
              </Box>
            </Box>
          )}
          <Box
            sx={{
              width: { xs: "295px", sm: "600px" },
              height: { xs: "221px", sm: "338px" },
              borderRadius: { xs: "8px", sm: "16px" },
              border: "1px solid 1f1f1f",
              backgroundColor: "#1f1f1f",
              filter: {
                xs: "drop-shadow(0px 4px 5px rgba(0, 0, 0, 0.14)) drop-shadow(0px 1px 10px rgba(0, 0, 0, 0.12)) drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.2))",
                sm: "none",
              },
              margin: { xs: "0 auto", sm: "0px" },
            }}
          ></Box>
        </Box>
      </Box>
    </Container>
  );
}

export default SuccessStories;
